import { render, staticRenderFns } from "./ShorexBookingItem.vue?vue&type=template&id=2acf9e16&scoped=true"
import script from "./ShorexBookingItem.vue?vue&type=script&lang=js"
export * from "./ShorexBookingItem.vue?vue&type=script&lang=js"
import style0 from "./ShorexBookingItem.vue?vue&type=style&index=0&id=2acf9e16&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acf9e16",
  null
  
)

export default component.exports